export default __webpack_public_path__ + "static/media/bitcoin.83706dfe.svg";